import RailsResource from './rails-resource';

export default new class ActivityService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'activities',
      ajaxLoader: false
    });
  }

  audienceStats() {
    return this.call(`${this.url}/${this.resource}/audience-stats`);
  }
}